import { render } from "./KamutPage.vue?vue&type=template&id=50c949be"
import script from "./KamutPage.vue?vue&type=script&lang=js"
export * from "./KamutPage.vue?vue&type=script&lang=js"

import "./KamutPage.vue?vue&type=style&index=0&id=50c949be&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__